export class RRHeaderTabOptionModel {
  name: string;
  link: string;
  hide?: boolean;
  disabled?: boolean;
}
